// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"678":"component---src-pages-index-js","883":"component---src-pages-404-js"}[chunkId] + "-" + {"678":"708f4bf09838194207f8","883":"073d3c8d8100647d3a23"}[chunkId] + ".js";
};